;(function () {
  angular.module('contrast.bar-chart').directive('csBarChart', csBarChart)

  function csBarChart($, $compile, dc) {
    'ngInject'

    var uniqueId = 1

    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      link: function ($scope, element) {
        var id = 'bar-chart-' + uniqueId++,
          parent = element.parent(),
          rendering = false,
          preRender = false

        element.attr('id', id)
        var chart = dc.barChart('#' + id).renderTitle(false)

        $scope.$watch(
          function () {
            return $scope.data
              ? $scope.data.data
              : $scope.$parent.data
              ? $scope.$parent.data.data
              : null
          },
          function (newValue) {
            if (newValue) {
              renderChart(true)
            }
          }
        )

        $scope.$watch(
          function () {
            return parent.width()
          },
          function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
              renderChart()
            }
          }
        )

        function renderChart(force) {
          if ($scope.data && $scope.data.data && (!rendering || force)) {
            rendering = true

            element.addClass('barchart-loading')

            $('.tooltip-barchart').remove()

            var ndx = crossfilter($scope.data.data),
              timeDimension = ndx.dimension(function (d) {
                return d.timestamp
              })

            var parentWidth = parent.width()

            var formatFunction = function (val) {
                return d3.time.format('%H:%M:%S')(val)
              },
              xAxisValues = d3.time.second.range(
                $scope.data.minTime,
                $scope.data.maxTime + 1000,
                30
              ),
              xUnits = d3.time.second.range(
                $scope.data.minTime,
                $scope.data.maxTime,
                5
              ),
              startDate = moment($scope.data.minTime).toDate(),
              endDate = moment($scope.data.maxTime).toDate(),
              timeDomain = d3.time.scale().domain([startDate, endDate]),
              clickHandler = $scope.data.clickHandler

            var height = 80

            element.css('height', height + 'px')

            chart
              .width((parentWidth < 0 ? 0 : parentWidth) + 40)
              .height(height)
              .clipPadding(20)
              .x(timeDomain)
              .xUnits(
                $scope.data.barWidth ||
                  function () {
                    return xUnits.length
                  }
              )
              .centerBar(true)
              .dimension(timeDimension)
              .brushOn(false)
              .y(
                d3.scale
                  .linear()
                  .domain([
                    $scope.data.min ? $scope.data.min : 0,
                    $scope.data.max
                  ])
              )

            chart.xAxis().tickFormat(formatFunction)

            chart.xAxis().tickValues(xAxisValues)

            if ($scope.data.chartMethods) {
              $scope.data.chartMethods(chart)
            }

            $scope.data.config.forEach(function (config, i) {
              var valueGroup = timeDimension.group().reduceSum(config.group)
              if (i == 0) {
                chart.group(valueGroup)
              } else {
                chart.stack(valueGroup)
              }
            })

            chart.on('postRender', function (chart) {
              var i = 0
              angular.forEach($scope.data.config, function (config) {
                if (config.class) {
                  chart.select('g.stack._' + i).classed(config.class, true)
                }

                chart
                  .selectAll('g.stack._' + i + ' rect.bar')
                  .attr('width', '10')

                if (config.class == 'bar-chart-transparent') {
                  chart
                    .selectAll('g.stack._' + i + ' rect.bar')
                    .attr('transform', function (item) {
                      return (
                        'translate(0, ' +
                        (height / 2) * (item.y / $scope.data.max) +
                        ')'
                      )
                    })
                    .attr('cs-bar-chart-tooltip', '')
                    .attr('cs-bar-chart-tooltip-placement', 'auto right')
                    .attr('bar-chart-time', function (item) {
                      return item.x
                    })
                    .attr('cs-bar-chart-tooltip-total', function (item) {
                      var time = item.x,
                        point = $scope.data.data.find(function (datum) {
                          return datum.timestamp == time
                        })

                      return point ? point.total_events : 0
                    })
                    .attr('cs-bar-chart-tooltip-exploited', function (item) {
                      var time = item.x,
                        point = $scope.data.data.find(function (datum) {
                          return datum.timestamp == time
                        })

                      return point ? point.exploited_events : 0
                    })
                    .attr('cs-bar-chart-tooltip-probed', function (item) {
                      var time = item.x,
                        point = $scope.data.data.find(function (datum) {
                          return datum.timestamp == time
                        })

                      return point ? point.probed_events : 0
                    })
                    .attr('cs-bar-chart-tooltip-blocked', function (item) {
                      var time = item.x,
                        point = $scope.data.data.find(function (datum) {
                          return datum.timestamp == time
                        })

                      return point ? point.blocked_events : 0
                    })
                    .attr('cs-bar-chart-tooltip-requests', function (item) {
                      var time = item.x,
                        point = $scope.data.data.find(function (datum) {
                          return datum.timestamp == time
                        })

                      return point ? point.requests_per_second : 0
                    })
                    .on('click', clickHandler ? clickHandler : function () {})
                }

                i++
              })

              if (element.hasClass('barchart-compact')) {
                chart
                  .select('g.chart-body')
                  .attr('transform', 'translate(20, 4)')
              } else {
                chart
                  .select('g.chart-body')
                  .attr('transform', 'translate(20, 10)')

                chart
                  .selectAll('g.axis.x g.tick')
                  .attr('cs-bar-chart-tooltip', '')
                  .attr('cs-bar-chart-tooltip-placement', 'auto bottom')
                  .attr('cs-bar-chart-tooltip-requests', function (item) {
                    var timeDate = item,
                      time = timeDate ? timeDate.getTime() : 0,
                      timeRange = 5000 / 2,
                      point = $scope.data.data.find(function (datum) {
                        return (
                          datum.timestamp >= time - timeRange &&
                          datum.timestamp <= time + timeRange
                        )
                      })

                    return point ? point.requests_per_second : 0
                  })
              }

              if (preRender) {
                $compile(element)($scope)
              }
              preRender = false
              rendering = false

              if (parentWidth != parent.width()) {
                renderChart(true)
              } else {
                element.removeClass('barchart-loading')
              }
            })

            preRender = true

            chart.render()
          }
        }
      }
    }
  }
})()
